import {
  Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject,
} from '@triare/auth-redux';
import {
  put, delay, takeLatest, call,
} from 'redux-saga/effects';
import { actions } from './index';

export type SubCategoryDeleteData = AnyObject;

export type SubCategoryDeleteResponse = SubCategoryDeleteData;

export interface SubCategoryDelete {
  id: string;
}

export const subCategoryDelete = (payload: SubCategoryDelete): Action<SubCategoryDelete> => ({
  type: actions.subCategoryDeleteTrigger.toString(),
  payload,
});

export const subCategoryDeleteClear = (): Action => ({
  type: actions.subCategoryDeleteClear.toString()
});

export const subCategoryDeleteErrorClear = (): Action => ({
  type: actions.subCategoryDeleteErrorReset.toString()
});

export function* subCategoryDeleteRequestSaga({ payload }: Action<SubCategoryDelete>) {
  yield put({
    type: actions.subCategoryDeleteStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.subCategoryDeleteError.toString(),
      payload: {
        message: 'SubCategoryDelete: Parameters not passed.',
      },
    });

    return;
  }

  const { id } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}sub-categories/${id}`,
    {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json', },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<SubCategoryDeleteData, SubCategoryDeleteResponse>(
    response,
    actions.subCategoryDeleteSuccess.toString(),
    actions.subCategoryDeleteError.toString(),
    false,
    (subCategoryDeleteData) => subCategoryDeleteData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.subCategoryDeleteTrigger.toString(),
    defaultProcessingSaga(
      subCategoryDeleteRequestSaga,
      {
        error: actions.subCategoryDeleteError.toString(),
        locationCancel: actions.subCategoryDeleteClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.subCategoryDeleteSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }

    // yield put({
    //   type: actions.subCategoryDeleteClear.toString(),
    // });
  });

  yield takeLatest(actions.subCategoryDeleteError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.subCategoryDeleteErrorReset.toString(),
    });
  });
}
